import styled from 'styled-components';

export default styled.section`
	display: grid;
	grid-template-columns: var(--grid-template-columns);
	grid-template-rows: var(--grid-template-rows);
	grid-gap: var(--gap);
	padding: 0.75rem 1.5rem;
	align-items: center;

	&.data-headers{
		background-color: var(--neutrals-25);
		border-color: red;
		border-top-left-radius: 0.8rem;
		border-top-right-radius: 0.8rem;
		height: 3rem;
		align-content: center;
		.headers{
			display: flex;
			align-items: center;
			.motif-icon{
				svg{
					fill: ${(props) => props.theme.color[`grey400`]};
				}
			}
		}

		.entity-header{
			width: unset;
		}
	}

	.motif-text-alt-button{
		font-size: 1.4rem;
		font-weight: 600;
		box-shadow: none;
		&:focus,
		&:hover{
			box-shadow: none;
			border-bottom: 0;
		}
	} 
`;
